import { observer } from 'mobx-react-lite'
import { offlineSyncManager } from '../OfflineSync'
import type { OfflineMutation } from '../OfflineSync'
import styles from './SyncErrorAlert.module.css'

function getMutationLabel(m: OfflineMutation): string {
    switch (m.type) {
        case 'status-change':
            return `Зміна статусу (→ ${m.newStatus ?? '?'})`
        case 'delay-report':
            return 'Звіт про затримку'
        case 'complete-task':
            return 'Завершення завдання'
        default:
            return 'Дія'
    }
}

export const SyncErrorAlert = observer(() => {
    const { failedMutations } = offlineSyncManager

    if (failedMutations.length === 0) return null

    const count = failedMutations.length
    const countLabel = count === 1 ? '1 дію' : `${count} дії`

    return (
        <div className={styles['container']} role="alert">
            <div className={styles['header']}>
                ⚠️ Не вдалось синхронізувати {countLabel}
            </div>
            <div className={styles['list']}>
                {failedMutations.map((m) => (
                    <div key={m.id} className={styles['item']}>
                        <span className={styles['label']}>{getMutationLabel(m)}</span>
                        {m.lastError && (
                            <span className={styles['error']}>{m.lastError}</span>
                        )}
                    </div>
                ))}
            </div>
            <div className={styles['batchActions']}>
                <button
                    className={styles['btnRetry']}
                    onClick={() => offlineSyncManager.retryAllFailed()}
                >
                    Повторити все
                </button>
                <button
                    className={styles['btnDiscard']}
                    onClick={() => offlineSyncManager.discardAllFailed()}
                >
                    Відхилити
                </button>
            </div>
        </div>
    )
})

SyncErrorAlert.displayName = 'SyncErrorAlert'
